import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import MuiDialogContent from '@mui/material/DialogActions';
import { Alert } from '@mui/material';
import useStyles from './styles';

const Modal = ({ title, children, contentProps, dates, customButtons: DialogActions, ...rest }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { classes } = useStyles();

    return (
        <Dialog
            fullWidth
            fullScreen={isMobile}
            {...rest}
        >
            { 
                title &&
                
                <DialogTitle>
                    {title}
                    { dates > 30 && <Alert className={classes.warning} severity="warning">{dates} dias</Alert>}
                </DialogTitle> 
                  
            }
            <DialogContent {...contentProps}>
                {children}
            </DialogContent>
            {
                DialogActions &&
                <DialogActions />
            }
        </Dialog>
    )
}

Modal.prototype = {
    title: PropTypes.string,
    contentProps: PropTypes.object,
    customButtons: PropTypes.instanceOf(MuiDialogContent)
}

export default Modal;